<template>
  <section>
    <div
        class="UploadFile-container"
        :class="{ 'mobile-upload-container': isMobile }"
    >
      <template v-if="innerValue.length">
        <transition-group
            :class="`el-upload-list el-upload-list--picture-card transition-group-${type}`"
            tag="ul"
            name="el-list"
        >
          <li
              class="el-upload-list__item is-success"
              v-for="(file, index) in innerValue"
              :key="file.id"
              :style="{
              width: type === 2 ? `calc(${photoWidth}px / 3)` : '',
              height: type === 2 ? `calc(${photoHeight}px / 3)` : '',
            }"
          >
            <el-image
                :ref="'image' + index"
                :src="`${baseURL}/dms/file/stream?type=0&id=${
                file.id
              }&token=${token}&time=${timestamp()}`"
                class="el-upload-list__item-thumbnail"
                :preview-src-list="getImgList(innerValue)"
                :z-index="9999"
                fit="cover"
            />
            <div
                v-if="isMobile && !disabled"
                class="mobile-del-btn"
                @click="handleRemove(index)"
            >
              <i class="el-icon-circle-close" />
            </div>
            <span v-else class="el-upload-list__item-actions">
              <span
                  class="el-upload-list__item-preview"
                  @click="handlePictureCardPreview(index)"
              >
                <i class="el-icon-zoom-in" />
              </span>
              <span
                  v-if="!disabled"
                  class="el-upload-list__item-delete"
                  @click="handleRemove(index)"
              >
                <i class="el-icon-delete" />
              </span>
            </span>
          </li>
        </transition-group>
      </template>
      <div
          v-if="
          (disabled && !innerValue.length) ||
          (((limit && innerValue.length < limit) || !limit) && !disabled)
        "
          :class="{ 'is-disabled': disabled, 'mobile-upload-btn': isMobile }"
          class="upload-btn"
          @click="selectImg"
      >
        <div
            :class="`el-upload el-upload--picture-card upload-block-${type}`"
            :style="{
            width: type === 2 ? `calc(${photoWidth}px / 3)` : '',
            height: type === 2 ? `calc(${photoHeight}px / 3)` : '',
            lineHeight: type === 2 ? `calc(${photoHeight}px / 3)` : '',
          }"
        >
          <i :class="isMobile ? 'el-icon-camera-solid' : 'el-icon-plus'" />
        </div>
      </div>
      <div
          class="el-upload__tip"
          v-show="showTip && (fileSize || accept !== 'image/*')"
      >
        只能上传{{ fileSize ? `不超过${fileSize}${sizeUnit}的` : ""
        }}{{
          accept === "*" || !accept
              ? "文件"
              : fileTypeList
                  .filter((item) => accept.includes(item.value))
                  .map((item) => item.label)
                  .toString()
        }}图片
      </div>
    </div>

    <div id="global-uploader">
      <!-- 上传 -->
      <uploader
          ref="uploader"
          :auto-start="false"
          class="uploader-app"
          :file-status-text="fileStatusText"
          :options="handleOptions"
          @file-complete="fileComplete"
          @file-error="onFileError"
          @file-progress="onFileProgress"
          @file-success="onFileSuccess"
          @files-added="onFilesAdded"
      >
        <uploader-unsupport />
        <uploader-btn
            v-if="(limit && innerValue.length < limit) || !limit"
            id="rock-uploader-partial-btn"
            ref="uploadBtn"
            :attrs="attrs"
            :single="!type && limit === 1"
        >选择图片
        </uploader-btn>
        <uploader-list v-show="panelShow">
          <div slot-scope="scope" class="file-panel">
            <div class="file-title">
              <div class="title">上传列表</div>
              <div class="middle"></div>
              <div class="operate">
                <span class="warning-about-empty-folder"
                >空文件夹不会被上传</span
                >
                <el-button title="收起" type="text" @click="close">
                  <i class="el-icon-minus"></i>
                </el-button>
                <el-button title="关闭" type="text" @click="closeCache">
                  <i class="el-icon-close"></i>
                </el-button>
              </div>
            </div>

            <div class="file-list">
              <uploader-files ref="files" :file="scope.fileList" :list="true" />
              <div v-if="!scope.fileList.length" class="no-file">
                <el-image
                    :src="require('@/assets/images/data_empty.png')"
                    style="width: 300px; height: 200px"
                />
              </div>
            </div>
          </div>
        </uploader-list>
      </uploader>
    </div>
  </section>
</template>

<script>
import Uploader from "vue-simple-uploader";
import SparkMD5 from "spark-md5";
import { baseURL, tokenName } from "@/config/net.config";
import { checkUpload, mergeUpload } from "@/api/publicApi";
import { mapGetters } from "vuex";
// 引入vant
import { Toast, Dialog } from "vant";
import "vant/lib/toast/style";
import "vant/lib/dialog/style";

const units = {
  KB: 1024,
  MB: 1024 * 1024,
  GB: 1024 * 1024 * 1024,
};

export default {
  name: "RockUploaderImg",
  install(Vue) {
    Vue.component("RockUploaderImg", this);
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    type: {
      type: Number,
      default: 0, // 0：默认，1：身份证，2：照片，3：核酸检测报告，4：支付宝健康码，5：通信行程卡
    },
    photoAccept: {
      // 照片类型，小一寸390*260、一寸413*295、大一寸567*390、二寸413*626
      type: String,
      default: "413*295",
    },
    rangeNow: {
      // 距今时间范围，核酸检测报告、支付宝健康码、通信行程卡使用
      type: Number,
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    showTip: {
      type: Boolean,
      default: false,
    },
    limit: {
      type: Number,
      default: 1,
    },
    accept: {
      type: String,
      default: "image/*",
    },
    fileSize: {
      default: 2,
    },
    sizeUnit: {
      type: String,
      default: "MB",
    },
    uploaderOptions: {
      type: Object,
      default: () => ({}),
    },
    uploadType: {
      type: Number,
      default: 1, // 0：全部，1：上传文件，2：上传文件夹
    },
    size: {
      type: Object,
      default: () => ({
        minWidth: 0,
        maxWidth: 0,
        minHeight: 0,
        maxHeight: 0,
      }),
    },
  },
  components: {
    Uploader: Uploader.Uploader,
    // UploaderDrop: Uploader.UploaderDrop,
    UploaderBtn: Uploader.UploaderBtn,
    UploaderUnsupport: Uploader.UploaderUnsupport,
    UploaderList: Uploader.UploaderList,
    UploaderFiles: Uploader.UploaderFiles,
    // UploaderFile: Uploader.UploaderFile,
  },
  data() {
    return {
      baseURL,
      hideSuccess: false,
      options: {
        target: baseURL + "/dms/file/upload/chunk",
        chunkSize: 5 * 1024 * 1024, // 每个上传的数据块的大小（以字节为单位）默认: 1*1024*1024
        fileParameterName: "file", // 用于文件块的多部分 POST 参数的名称
        maxChunkRetries: undefined, // 上传失败前块的最大重试次数。有效值是任何正整数并且undefined没有限制。(默认: 0)
        simultaneousUploads: 10, // 同时上传的数量（默认值：3）
        allowDuplicateUploads: false, // 传文件后，允许重新上传相同的文件。默认情况下，如果一个文件已经上传，它将被跳过，除非该文件从现有的 Uploader 对象中删除。(默认: false)
        testChunks: true, //是否开启服务器分片校验
        initialPaused: false, // 初始暂停状态，默认false
        // 服务器分片校验函数，秒传及断点续传基础
        checkChunkUploadedByResponse: function (chunk, message) {
          let objMessage = JSON.parse(message);
          if (objMessage.code === 2001) {
            // 1 秒传
            return true;
          } else {
            // 没传过
            return (objMessage.data || []).indexOf(chunk.offset + 1) >= 0;
          }
        },
        headers: { token: localStorage.getItem(tokenName) },
        query: {
          key: "4",
          parent: "0",
          type: 4,
        },
      },
      attrs: {
        accept: "image/*",
      },
      index: 0,
      panelShow: false, //选择文件后，展示上传panel
      loading: undefined, // 上传中加载

      fileTypeList: [
        { label: "JPG", value: "image/jpeg" },
        { label: "PNG", value: "image/png" },
      ],
    };
  },
  computed: {
    ...mapGetters({
      screenWidth: "screenWidth",
    }),

    isMobile() {
      return this.screenWidth <= 425;
    },

    innerValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },

    //Uploader实例
    uploader() {
      return this.$refs.uploader.uploader;
    },
    handleOptions() {
      const options = { ...this.options, ...this.uploaderOptions };
      if (this.uploaderOptions.chunkSize)
        options.chunkSize =
            this.uploaderOptions.chunkSize * units[this.chunkSizeUnit];
      return options;
    },
    token() {
      return localStorage.getItem(tokenName);
    },
    photoWidth() {
      return parseInt(this.photoAccept.split("*")[1]);
    },
    photoHeight() {
      return parseInt(this.photoAccept.split("*")[0]);
    },
  },
  watch: {
    accept(val) {
      this.attrs.accept = val;
    },
  },
  methods: {
    timestamp() {
      return new Date().getTime();
    },
    selectImg() {
      if (!this.disabled) this.$refs.uploadBtn.$el.click();
    },

    // 用作多个文件的校验。如果说返回了 false，那么这个文件就会被忽略，不会添加到文件上传列表中。
    async onFilesAdded(files) {
      if (!this.type) {
        // 限制单次最大上传数量
        const limitation = 300;
        if (files.length > limitation) {
          if (this.isMobile) {
            Dialog.alert({
              title: "提示",
              message: `文件过多，单次最多可上传${limitation}个文件！`,
            }).then(() => {
              this.clearFile(files);
              return false;
            });
          } else {
            await this.$alert(
                `文件过多，单次最多可上传${limitation}个文件！`,
                "提示",
                {
                  confirmButtonText: "确定",
                  callback: () => {
                    this.clearFile(files);
                  },
                }
            );
          }
          return false;
        }
        // 限制最大上传数量
        if (
            (this.innerValue.length === this.limit ||
                files.length > this.limit) &&
            this.limit
        ) {
          if (this.isMobile) {
            Dialog.alert({
              title: "提示",
              message: `当前限制最多可以上传${this.limit}个文件！`,
            }).then(() => {
              this.clearFile(files);
              return false;
            });
          } else {
            await this.$alert(
                `当前限制最多可以上传${this.limit}个文件！`,
                "提示",
                {
                  confirmButtonText: "确定",
                  callback: () => {
                    this.clearFile(files);
                  },
                }
            );
          }
          return false;
        }
      }

      // 限制文件类型和单个文件最大大小
      const unitNum = units[this.sizeUnit];
      let isRightSize = true;
      let isAccept = true;
      for (const file of files) {
        // isAccept = new RegExp(this.accept).test(file.fileType);
        isAccept =
            this.accept === "image/*" || this.accept.includes(file.fileType);
        if (!isAccept) {
          const type = this.fileTypeList
              .filter((item) => this.accept.includes(item.value))
              .map((item) => item.label)
              .toString();
          if (this.isMobile) {
            Dialog.alert({
              title: "提示",
              message: `应该选择${type}类型的文件！`,
            }).then(() => {
              this.clearFile(files);
              return false;
            });
          } else {
            await this.$alert(`应该选择${type}类型的文件！`, "提示", {
              confirmButtonText: "确定",
              // eslint-disable-next-line no-unused-vars
              callback: () => {
                this.clearFile(files);
              },
            });
          }
          return false;
        }

        if (!this.fileSize) return true;
        isRightSize = file.size / unitNum < this.fileSize;
        if (!isRightSize) {
          if (this.isMobile) {
            Dialog.alert({
              title: "提示",
              message: `文件大小超过${this.fileSize}${this.sizeUnit}！`,
            }).then(() => {
              this.clearFile(files);
              return false;
            });
          } else {
            await this.$alert(
                `文件大小超过${this.fileSize}${this.sizeUnit}！`,
                "提示",
                {
                  confirmButtonText: "确定",
                  callback: () => {
                    this.clearFile(files);
                  },
                }
            );
          }
          return false;
        }

        // 限制图片长度和宽度
        try {
          await this.checkImgSize(files, file);
        } catch (e) {
          return false;
        }
      }
      if (this.isMobile) {
        this.loading = this.$loading({
          text: "正在上传...",
          background: "rgba(255, 255, 255, 0.8)",
          lock: true,
        });
      } else this.panelShow = true;

      files.forEach((file) => {
        this.do_preCheck(file);
      });
    },

    checkImgSize(files, file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = (e) => {
          const dataUrl = e.target.result;
          const img = new Image();
          img.onload = () => {
            let valid = true;
            if (this.size.minWidth && img.width < this.size.minWidth)
              valid = false;
            if (this.size.minHeight && img.height < this.size.minHeight)
              valid = false;
            if (this.size.maxWidth && img.width > this.size.maxWidth)
              valid = false;
            if (this.size.maxHeight && img.height > this.size.maxHeight)
              valid = false;
            valid ? resolve(true) : reject(false);
          };
          img.src = dataUrl;
        };
        reader.readAsDataURL(file.file);
      }).then(
          () => {
            return file;
          },
          () => {
            let text1 = "";
            let text2 = "";
            if (this.size.minWidth && this.size.minHeight)
              text1 = `图片最小尺寸为${this.size.minWidth} * ${this.size.minHeight}px`;
            else if (this.size.minWidth)
              text1 = `图片最小长度为${this.size.minWidth}px`;
            else if (this.size.minHeight)
              text1 = `图片最小宽度为${this.size.minHeight}px`;
            if (this.size.maxWidth && this.size.maxHeight)
              text1 = `图片尺寸不超过${this.size.maxWidth} * ${this.size.maxHeight}px`;
            else if (this.size.maxWidth)
              text1 = `图片长度不超过${this.size.maxWidth}px`;
            else if (this.size.maxHeight)
              text1 = `图片宽度不超过${this.size.maxHeight}px`;
            if (this.isMobile) {
              Dialog.alert({
                title: "提示",
                message: `${text1}${text1 && text2 ? "，" : ""}${text2}！`,
              }).then(() => {
                this.clearFile(files);
              });
            } else {
              this.$alert(
                  `${text1}${text1 && text2 ? "，" : ""}${text2}！`,
                  "提示",
                  {
                    confirmButtonText: "确定",
                    callback: () => {
                      this.clearFile(files);
                    },
                  }
              );
            }
            return Promise.reject();
          }
      );
    },

    clearFile(files) {
      files.forEach((file) => {
        file.cancel();
      });
    },
    onFileProgress(rootFile, file, chunk) {
      // eslint-disable-next-line no-console
      console.log(
          `上传中 ${file.name}，chunk：${chunk.startByte / 1024 / 1024} ~ ${
              chunk.endByte / 1024 / 1024
          }`
      );
    },
    fileStatusText(status, response) {
      const statusTextMap = {
        uploading: "上传中...",
        paused: "等待中...",
        waiting: "等待中...",
      };
      if (status === "success") {
        return response.message;
      } else if (status === "error") {
        return "上传失败:" + response.message;
      } else {
        return statusTextMap[status];
      }
    },
    async onFileSuccess(rootFile, file, response) {
      let that = this;
      let res = JSON.parse(response);
      // 服务器自定义的错误（即虽返回200，但是是错误的情况），这种错误是Uploader无法拦截的
      if (
          res.code === 2006 ||
          res.code === 2004 ||
          res.code === 500 ||
          res.code === -1
      ) {
        file.error = true;
        that.fileStatusText("error", res);
        if (that.isMobile) {
          Toast.fail(res.message);
        } else {
          that.$notify.error({
            title: "错误",
            message: res.message,
          });
        }
        return;
      }
      const postData = {
        filename: file.name,
        identifier: file.uniqueIdentifier,
        relativePath: file.relativePath,
        totalSize: file.size,
      };
      const { code, data } = await mergeUpload(postData);
      if (code && code === 1 && data) {
        data.path =
            location.protocol +
            "//" +
            location.host +
            `${this.baseURL}/dms/file/stream?id=${
                data.id
            }&type=0&time=${new Date().getTime()}`;
        console.log(data)
        this.innerValue.push(data);
        this.$emit("input", this.innerValue);
        this.$emit("success");
        this.close();
      } else {
        file.error = true;
        that.fileStatusText("error", { message: data || "请求失败" });
        if (this.isMobile) this.loading.close();
        this.$emit("error");
        return false;
      }
    },

    // 一个根文件（文件夹）已完成。
    fileComplete() {
      // if (this.uploader.getSize() === this.uploader.sizeUploaded()) {
      // }
    },
    onFileError(rootFile, file, response) {
      this.fileStatusText("error", response);
      if (this.isMobile) this.loading.close();
      if (this.isMobile) {
        Toast.fail(response.message);
      } else {
        this.$notify.error({
          title: "错误",
          message: response.message,
        });
      }
    },
    async do_preCheck(files) {
      let suffix = "";
      let arr = files.name.split(".");
      if (arr.length >= 1) {
        suffix = "." + arr[arr.length - 1];
      }
      const postData = {
        size: files.size, // 文件体积，单位byte
        suffix: suffix, // 文档后缀(带点)
        relativePath: files.relativePath, // 文件夹上传的时候文件的相对路径属性（包括最后一个文件及其后缀）
      };
      const { code } = await checkUpload(postData);
      if (code && code === 1) {
        // $(".uploader-file-meta")
        //   .eq(this.index)
        //   .css("width", "12%")
        //   .css("color", "#1890ff")
        //   .text("附件");
        // $(".uploader-file-name").css("width", "41%");
        this.index += 1;
        this.computeMD5(files);
      } else {
        files.cancel();
        if (this.isMobile) this.loading.close();
      }
    },
    /**
     * 计算md5，实现断点续传及秒传
     * @param file
     */
    computeMD5(file) {
      let fileReader = new FileReader();
      let time = new Date().getTime();
      let blobSlice =
          File.prototype.slice ||
          File.prototype.mozSlice ||
          File.prototype.webkitSlice;
      let currentChunk = 0;
      const chunkSize = 10 * 1024 * 1000;
      let chunks = Math.ceil(file.size / chunkSize);
      let spark = new SparkMD5.ArrayBuffer();
      // file.cmd5 = true
      file.pause();

      loadNext();

      fileReader.onload = (e) => {
        spark.append(e.target.result);

        if (currentChunk < chunks) {
          currentChunk++;
          loadNext();

          // 实时展示MD5的计算进度
          // this.$nextTick(() => {
          //   $(`.myStatus_${file.id}`).text(
          //     "校验MD5 " + ((currentChunk / chunks) * 100).toFixed(0) + "%"
          //   );
          // });
        } else {
          let md5 = spark.end();
          // spark.destroy()
          this.computeMD5Success(md5, file);
          // eslint-disable-next-line no-console
          console.log(
              `MD5计算完毕：${file.name} \nMD5：${md5} \n分片：${chunks} 大小:${
                  file.size
              } 用时：${new Date().getTime() - time} ms`
          );
        }
      };

      fileReader.onerror = function () {
        this.error(`文件${file.name}读取出错，请检查该文件`);
        file.cancel();
      };

      function loadNext() {
        let start = currentChunk * chunkSize;
        let end =
            start + chunkSize >= file.size ? file.size : start + chunkSize;

        fileReader.readAsArrayBuffer(blobSlice.call(file.file, start, end));
      }
    },

    computeMD5Success(md5, file) {
      // 将自定义参数直接加载uploader实例的opts上
      // Object.assign(this.uploader.opts, {
      //   query: {
      //     ...this.params,
      //   },
      // })
      file.uniqueIdentifier = md5;
      // file.cmd5 = false
      file.resume();
    },
    close() {
      if (this.isMobile) this.loading.close();
      else this.panelShow = false;
    },
    closeCache() {
      this.uploader.cancel();
      this.index = 0;
      this.panelShow = false;
    },
    error(msg) {
      if (this.isMobile) {
        this.loading.close();
        Toast.fail({
          message: msg,
          duration: 2000,
        });
      } else {
        this.$notify.error({
          title: "错误",
          message: msg,
          duration: 2000,
        });
      }
    },
    // 删除已经上传成功的文件
    handleRemove(index) {
      this.innerValue.splice(index, 1);
      this.$emit("input", this.innerValue);
    },
    // 图片预览列表
    getImgList(fileList) {
      return fileList.map(
          (file) =>
              `${this.baseURL}/dms/file/stream?id=${file.id}&type=0&token=${
                  this.token
              }&time=${this.timestamp()}`
      );
    },
    handlePictureCardPreview(index) {
      this.$refs["image" + index][0].clickHandler();
    },
  },
};
</script>

<style scoped lang="scss">
#global-uploader {
  position: fixed;
  z-index: 9999;
  right: 8px;
  bottom: 8px;
  -webkit-box-shadow: 1px 1px 8px rgba(0, 0, 0, 0.12);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  background: #ffffff;
  border-radius: 4px;

  .uploader-app {
    width: 700px;
  }

  #uploadDrop {
    display: none;
    position: fixed;
    z-index: 99999;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.8);
    border: 10px dashed #ccc;
    color: #aaa;
    font-size: 60px;
    text-align: center;
  }

  .file-panel {
    background-color: #fff;
    border: 1px solid #e2e2e2;
    border-radius: 7px 7px 0 0;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);

    .file-title {
      display: flex;
      height: 40px;
      line-height: 40px;
      padding: 0 15px;
      border-bottom: 1px solid #ddd;

      .title {
        font-size: 20px;
        font-weight: 600;
      }

      .middle {
        .hide-success-box {
          margin-left: 20px;
        }
      }

      .operate {
        flex: 1;
        text-align: right;

        .warning-about-empty-folder {
          background: yellow;
          color: red;
          font-size: 14px;
          padding: 5px 10px 5px 6px;
          margin-right: 20px;
        }
      }
    }

    .file-list {
      position: relative;
      height: 350px;
      overflow-x: hidden;
      overflow-y: auto;
      background-color: #fff;
      padding: 5px 5px 5px 5px;
      margin: 0;

      ::v-deep {
        .uploader-file-status {
          text-align: center;
          text-indent: 0;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
  }

  .no-file {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 16px;
  }

  ::v-deep {
    .uploader-file-icon {
    }
  }

  ::v-deep {
    .uploader-file-actions > span {
      margin-right: 6px;
    }
  }
}

::v-deep .transition-group-0 .el-upload-list__item {
  width: 148px;
  height: 148px;
}

::v-deep .upload-block-0 {
  width: 148px;
  height: 148px;
  line-height: 148px;
}

::v-deep .transition-group-1 .el-upload-list__item {
  max-width: calc(85.6px * 3);
  width: 100%;
  max-height: calc(54px * 3);
  height: 100%;
}

.upload-block-1 {
  width: calc(85.6px * 3);
  height: calc(54px * 3);
  line-height: calc(54px * 3);
}

::v-deep .transition-group-2 .el-upload-list__item {
  width: calc(295px / 3);
  height: calc(413px / 3);
}

.upload-block-2 {
  width: calc(295px / 3);
  height: calc(413px / 3);
  line-height: calc(413px / 3);
}

::v-deep .transition-group-3 .el-upload-list__item {
  max-width: calc(75.8px * 3);
  width: 100%;
  max-height: calc(53.6px * 3);
  height: 100%;
}

.upload-block-3 {
  width: calc(75.8px * 3);
  height: calc(53.6px * 3);
  line-height: calc(53.6px * 3);
}

::v-deep .transition-group-4 .el-upload-list__item {
  max-width: calc(39px * 3);
  width: 100%;
  max-height: calc(84.4px * 2);
  height: 100%;
}

.upload-block-4 {
  width: calc(39px * 3);
  height: calc(84.4px * 2);
  line-height: calc(84.4px * 2);
}

::v-deep .transition-group-5 .el-upload-list__item {
  max-width: calc(39px * 3);
  width: 100%;
  max-height: calc(84.4px * 2);
  height: 100%;
}

.upload-block-5 {
  width: calc(39px * 3);
  height: calc(84.4px * 2);
  line-height: calc(84.4px * 2);
}

.upload-btn {
  display: inline-block;

  .el-upload--picture-card {
    background-color: #fff;
  }
}

.mobile-upload-btn {
  .el-upload--picture-card {
    border: none;
    border-radius: 3px;
    background-color: #f7f8fa;
  }

  ::v-deep .upload-block-0 {
    width: 80px;
    height: 80px;
    line-height: 88px;
  }

  .el-icon-camera-solid {
    color: #dcdee0;
  }
}

.mobile-upload-container {
  .mobile-del-btn {
    position: absolute;
    right: 0;
    top: 0;
    width: 24px;
    height: 24px;
    text-align: center;
    color: #fff;
    opacity: 1;

    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 0 0 0 24px;

    i {
      position: absolute;
      right: 2px;
      top: 2px;
      font-size: 15px;
    }
  }

  .transition-group-0 .el-upload-list__item {
    width: 80px;
    height: 80px;
    border: none;
    border-radius: 3px;
  }
}

.is-disabled {
  .el-upload--picture-card {
    cursor: default;
    background-color: #fbfdff;
  }

  .el-upload:hover {
    border-color: #c0ccda;
  }
}

/* 隐藏上传按钮 */
#rock-uploader-partial-btn {
  position: absolute;
  clip: rect(0, 0, 0, 0);
}
</style>
